import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { PaymentService } from '../../../../../../../../../services/payment/payment.service';

@Component({
  selector: 'app-preview-requested-payment-email-modal',
  templateUrl: './preview-requested-payment-email-modal.component.html',
  styleUrls: ['./preview-requested-payment-email-modal.component.css']
})
export class PreviewRequestedPaymentEmailModalComponent implements OnInit {
  @Input() invoiceId: number;
  @Input() amount: number | null;
  @Input() customNote: string;

  public loading = false;
  public errorMessage = '';

  public subject = '';
  public htmlContent = '';

  constructor(
    public activeModal: NgbActiveModal,
    private paymentService: PaymentService
  ) {}

  ngOnInit() {
    this.loading = true;

    this.paymentService
      .previewRequestedPaymentEmail(
        this.invoiceId,
        this.amount,
        this.customNote
      )
      .then(preview => {
        this.subject = preview.subject;
        this.htmlContent = preview.html;
      })
      .catch(reason => {
        if (reason.error && reason.error.useful_error_message) {
          this.errorMessage = reason.error.useful_error_message;
        } else {
          this.errorMessage = 'Failed to load email preview.';
        }
      })
      .finally(() => { this.loading = false; });
  }
}
